export const COLORS = {
  bg: '#07090A',
  surface: '#0D1113',
  accent: '#00C956',
  accentDark: '#00A449',
  text: '#E6F2EA',
  textDim: '#A7B4AF',
  border: 'rgba(255,255,255,0.08)',
};
